import { render, staticRenderFns } from "./CountUp.vue?vue&type=template&id=a4c9884a&scoped=true&"
import script from "./CountUp.vue?vue&type=script&lang=js&"
export * from "./CountUp.vue?vue&type=script&lang=js&"
import style0 from "./CountUp.vue?vue&type=style&index=0&id=a4c9884a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c9884a",
  null
  
)

export default component.exports